// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/images/baloa-background-login.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-email-code-verification-panel__container {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    gap: var( --grid-gap );
    grid-template-areas: "left left left left right right right right right right right right";
    height: 150vh;
    background-color: var( --white-color );
}

.signup-email-code-verification-panel__container__left-col {
    grid-area: left;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 150vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}

.signup-email-code-verification-panel__container__right-col {
    grid-column: 7 / 12;
}

.signup-email-code-verification-panel__container-title {
    margin-top: 175px;
    display: flex;
}

.signup-email-code-verification-panel__container-title .baloa-headline-1 {
    color: var(--primary-very-dark-color);    
    margin-right: var(--space-x2);
    cursor: pointer;
}

.signup-email-code-verification-panel__title {
    margin-bottom: calc( var( --space-x2 ) + var( --space-quarter ) + 2px );
}

.signup-email-code-verification-panel__text.baloa-normal {
    margin-bottom: var( --space-x3 );
    color: var( --primary-dark-color );
}

.signup-email-code-verification-panel__form__field {
    margin: var( --space-half ) 0 var( --space-x2 ) 0;
}

.signup-email-code-verification-panel__form__field .input-field-input {
    background: var(--white-color);
    border-radius: var( --space-half );
    border: 1.5px solid var(--new-gray-background-color);
    text-align: center;
    font-size: var(--space-and-half);
    font-family: var(--primary-font);
    letter-spacing: var(--space);
    line-height: var(--space-x2);
}

.signup-email-code-verification-panel__retry-code__valid-for {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
}

.signup-email-code-verification-panel__action-buttons {
    display: flex;
    justify-content: flex-end;
    margin-top: calc( var( --space-x3 ) + var( --space-half-quarter ) + 2px );
}

.signup-email-code-verification-panel__action-buttons__resend-btn {
    margin-right: calc( var( --space-and-half ) + 3px );
}


.signup-email-code-verification-panel__retry-code__valid-for__text-alert.baloa-names {
    margin-left: var( --space-quarter );
    color: var( --new-text-link-color );
}

.signup-email-code-verification-panel__retry-code__valid-for__text.baloa-names {
    font-weight: var(--font-regular);
    color: var( --new-text-link-color );
}

.signup-email-code-verification-panel__action-buttons__submit {
    background: #30B36B; /* TODO change to var */
    border-radius: calc( var( --space-quarter ) + 2px );
    color: var( --white-color );
}

.signup-email-code-verification-panel__action-buttons__resend-btn span,
.signup-email-code-verification-panel__action-buttons__submit span{
    text-transform: capitalize;
}

.signup-email-code-verification-panel__form__change-method {
    font-family: Roboto; /* TODO change to var */
    font-style: normal;
    font-weight: bold;
    font-size: calc( var( --space ) + 3px );
    line-height: calc( var( --space-and-half ) - 2px );
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: #30B36B; /* TODO change to var */
    margin-top: var( --space-x3 );
}

.signup-email-code-verification-panel__form__change-method {
    padding: 0;
}

.signup-email-code-verification-panel__form__change-method span {
    text-transform: none;    
}

.signup-email-code-verification-panel__form__label.baloa-table {
    font-weight: var(--font-medium);
    color: var(--primary-dark-color);
}

.signup-email-code-verification-panel__container__left-col img {
    width: 181px;
    margin-top: 68px;
    margin-left: 48px;
}

.signup-email-code-verification-panel__text span {
    color: var(--new-green-color);
    margin-left: 4px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .signup-email-code-verification-panel__container {
        display: block;
        height: 100vh;
    }
    .signup-email-code-verification-panel__container__left-col {
        height: 0;
        background-image: none;
    }
    .signup-email-code-verification-panel__container__left-col a {
        display: flex;
        justify-content: center;
    }
    .signup-email-code-verification-panel__container__left-col img {
        width: 100px;
        margin-top: calc( var(--space-x3) + var(--space-quarter) + var(--space-eighth));
        margin-left: 0;
    }
    .signup-email-code-verification-panel__container-title {
        justify-content: flex-start;
        width: 100%;
        margin: 112px 16px 24px 16px;
        align-items: center;
    }
    .signup-email-code-verification-panel__container-title .baloa-headline-1 {
        font-size:var(--space-and-half);
        margin-bottom: 0;
    }
    .signup-email-code-verification-panel__text {
        justify-content: center;
        margin-left: var(--space);
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: var(--space);
    }
    .signup-email-code-verification-panel__text span {
        margin-left: 0;
    }
    .signup-email-code-verification-panel__form__label {
        display: none;
    }
    .signup-email-code-verification-panel__form__field {
        margin-left:var(--space);
        margin-bottom: var(--space);
        margin-right: var(--space);
    }

    .signup-email-code-verification-panel__retry-code__valid-for {
        flex-direction: column;
        align-items: center;
    }

    .signup-email-code-verification-panel__retry-code__valid-for__text {
        margin-bottom: var(--space);
    }
    .signup-email-code-verification-panel__action-buttons {
        flex-direction: column;
        align-items: center;
        margin-top: 0;
        bottom: 0;
        position: absolute;
        width: 95%;
    }
    .signup-email-code-verification-panel__action-buttons__resend-btn {
        margin-right: 0;
    }
    .signup-email-code-verification-panel__action-buttons .button {
        width: 100%;
        margin-bottom: var(--space);
        margin-left: var(--space);
    }
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/components/signup-email-code-verification-panel/SignUpEmailCodeVerificationPanelComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sCAAsC;IACtC,wBAAwB;IACxB,sBAAsB;IACtB,0FAA0F;IAC1F,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,yDAA6E;IAC7E,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,uEAAuE;AAC3E;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,8BAA8B;IAC9B,kCAAkC;IAClC,oDAAoD;IACpD,kBAAkB;IAClB,gCAAgC;IAChC,gCAAgC;IAChC,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,yEAAyE;AAC7E;;AAEA;IACI,mDAAmD;AACvD;;;AAGA;IACI,mCAAmC;IACnC,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,mBAAmB,EAAE,uBAAuB;IAC5C,mDAAmD;IACnD,2BAA2B;AAC/B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB,EAAE,uBAAuB;IAC5C,kBAAkB;IAClB,iBAAiB;IACjB,uCAAuC;IACvC,kDAAkD;IAClD,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,cAAc,EAAE,uBAAuB;IACvC,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,cAAc;QACd,aAAa;IACjB;IACA;QACI,SAAS;QACT,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,YAAY;QACZ,+EAA+E;QAC/E,cAAc;IAClB;IACA;QACI,2BAA2B;QAC3B,WAAW;QACX,4BAA4B;QAC5B,mBAAmB;IACvB;IACA;QACI,+BAA+B;QAC/B,gBAAgB;IACpB;IACA;QACI,uBAAuB;QACvB,yBAAyB;QACzB,sBAAsB;QACtB,uBAAuB;QACvB,2BAA2B;IAC/B;IACA;QACI,cAAc;IAClB;IACA;QACI,aAAa;IACjB;IACA;QACI,wBAAwB;QACxB,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,2BAA2B;IAC/B;IACA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,aAAa;QACb,SAAS;QACT,kBAAkB;QAClB,UAAU;IACd;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,2BAA2B;QAC3B,yBAAyB;IAC7B;AACJ","sourcesContent":[".signup-email-code-verification-panel__container {\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    grid-template-rows: auto;\n    gap: var( --grid-gap );\n    grid-template-areas: \"left left left left right right right right right right right right\";\n    height: 150vh;\n    background-color: var( --white-color );\n}\n\n.signup-email-code-verification-panel__container__left-col {\n    grid-area: left;\n    background-image: url(\"../../../../assets/images/baloa-background-login.png\");\n    height: 150vh;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.signup-email-code-verification-panel__container__right-col {\n    grid-column: 7 / 12;\n}\n\n.signup-email-code-verification-panel__container-title {\n    margin-top: 175px;\n    display: flex;\n}\n\n.signup-email-code-verification-panel__container-title .baloa-headline-1 {\n    color: var(--primary-very-dark-color);    \n    margin-right: var(--space-x2);\n    cursor: pointer;\n}\n\n.signup-email-code-verification-panel__title {\n    margin-bottom: calc( var( --space-x2 ) + var( --space-quarter ) + 2px );\n}\n\n.signup-email-code-verification-panel__text.baloa-normal {\n    margin-bottom: var( --space-x3 );\n    color: var( --primary-dark-color );\n}\n\n.signup-email-code-verification-panel__form__field {\n    margin: var( --space-half ) 0 var( --space-x2 ) 0;\n}\n\n.signup-email-code-verification-panel__form__field .input-field-input {\n    background: var(--white-color);\n    border-radius: var( --space-half );\n    border: 1.5px solid var(--new-gray-background-color);\n    text-align: center;\n    font-size: var(--space-and-half);\n    font-family: var(--primary-font);\n    letter-spacing: var(--space);\n    line-height: var(--space-x2);\n}\n\n.signup-email-code-verification-panel__retry-code__valid-for {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n}\n\n.signup-email-code-verification-panel__action-buttons {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: calc( var( --space-x3 ) + var( --space-half-quarter ) + 2px );\n}\n\n.signup-email-code-verification-panel__action-buttons__resend-btn {\n    margin-right: calc( var( --space-and-half ) + 3px );\n}\n\n\n.signup-email-code-verification-panel__retry-code__valid-for__text-alert.baloa-names {\n    margin-left: var( --space-quarter );\n    color: var( --new-text-link-color );\n}\n\n.signup-email-code-verification-panel__retry-code__valid-for__text.baloa-names {\n    font-weight: var(--font-regular);\n    color: var( --new-text-link-color );\n}\n\n.signup-email-code-verification-panel__action-buttons__submit {\n    background: #30B36B; /* TODO change to var */\n    border-radius: calc( var( --space-quarter ) + 2px );\n    color: var( --white-color );\n}\n\n.signup-email-code-verification-panel__action-buttons__resend-btn span,\n.signup-email-code-verification-panel__action-buttons__submit span{\n    text-transform: capitalize;\n}\n\n.signup-email-code-verification-panel__form__change-method {\n    font-family: Roboto; /* TODO change to var */\n    font-style: normal;\n    font-weight: bold;\n    font-size: calc( var( --space ) + 3px );\n    line-height: calc( var( --space-and-half ) - 2px );\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: #30B36B; /* TODO change to var */\n    margin-top: var( --space-x3 );\n}\n\n.signup-email-code-verification-panel__form__change-method {\n    padding: 0;\n}\n\n.signup-email-code-verification-panel__form__change-method span {\n    text-transform: none;    \n}\n\n.signup-email-code-verification-panel__form__label.baloa-table {\n    font-weight: var(--font-medium);\n    color: var(--primary-dark-color);\n}\n\n.signup-email-code-verification-panel__container__left-col img {\n    width: 181px;\n    margin-top: 68px;\n    margin-left: 48px;\n}\n\n.signup-email-code-verification-panel__text span {\n    color: var(--new-green-color);\n    margin-left: 4px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .signup-email-code-verification-panel__container {\n        display: block;\n        height: 100vh;\n    }\n    .signup-email-code-verification-panel__container__left-col {\n        height: 0;\n        background-image: none;\n    }\n    .signup-email-code-verification-panel__container__left-col a {\n        display: flex;\n        justify-content: center;\n    }\n    .signup-email-code-verification-panel__container__left-col img {\n        width: 100px;\n        margin-top: calc( var(--space-x3) + var(--space-quarter) + var(--space-eighth));\n        margin-left: 0;\n    }\n    .signup-email-code-verification-panel__container-title {\n        justify-content: flex-start;\n        width: 100%;\n        margin: 112px 16px 24px 16px;\n        align-items: center;\n    }\n    .signup-email-code-verification-panel__container-title .baloa-headline-1 {\n        font-size:var(--space-and-half);\n        margin-bottom: 0;\n    }\n    .signup-email-code-verification-panel__text {\n        justify-content: center;\n        margin-left: var(--space);\n        flex-direction: column;\n        align-items: flex-start;\n        margin-bottom: var(--space);\n    }\n    .signup-email-code-verification-panel__text span {\n        margin-left: 0;\n    }\n    .signup-email-code-verification-panel__form__label {\n        display: none;\n    }\n    .signup-email-code-verification-panel__form__field {\n        margin-left:var(--space);\n        margin-bottom: var(--space);\n        margin-right: var(--space);\n    }\n\n    .signup-email-code-verification-panel__retry-code__valid-for {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .signup-email-code-verification-panel__retry-code__valid-for__text {\n        margin-bottom: var(--space);\n    }\n    .signup-email-code-verification-panel__action-buttons {\n        flex-direction: column;\n        align-items: center;\n        margin-top: 0;\n        bottom: 0;\n        position: absolute;\n        width: 95%;\n    }\n    .signup-email-code-verification-panel__action-buttons__resend-btn {\n        margin-right: 0;\n    }\n    .signup-email-code-verification-panel__action-buttons .button {\n        width: 100%;\n        margin-bottom: var(--space);\n        margin-left: var(--space);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
